<template>
  <form @submit.prevent="onSubmit">
    <div class="form-group">
      <password-field
        :key="renderKey"
        v-model="oldPassword"
        :data-vv-scope="'password_update'"
        name="old_password"
        label="Current Password"
        validation="required"
      />
    </div>
    <div class="form-group">
      <password-field
        :key="renderKey"
        v-model="newPassword"
        :data-vv-scope="'password_update'"
        name="new_password"
        label="New Password"
        validation="required"
      />
    </div>

    <div
      :class="{'has-error': allFilled() && !passwordsMatch()}"
      class="form-group"
    >
      <password-field
        :key="renderKey"
        v-model="confirmNewPassword"
        :data-vv-scope="'password_update'"
        name="confirm_new_password"
        label="Confirm New Password"
        validation="required"
      />

      <span
        v-if="allFilled() && !passwordsMatch()"
        class="help-block"
      >Passwords do not match</span>
    </div>

    <button
      :disabled="!(allFilled() && passwordsMatch())"
      type="submit"
      class="btn btn-primary pull-right"
    >
      Submit
    </button>
  </form>
</template>

<script>
import _ from 'lodash';
import PasswordField from '../../partials/field/password.vue';

export default {
  components: {
    PasswordField,
  },
  data() {
    return {
      oldPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      // We use this to re render the inputs when we update the modeled fields.
      // It is non conventional but won't work otherwise with the current form
      // input components.
      renderKey: 1,
    };
  },
  methods: {
    allFilled() {
      return !!this.oldPassword && !!this.newPassword && !!this.confirmNewPassword;
    },
    passwordsMatch() {
      return this.newPassword === this.confirmNewPassword;
    },
    onSubmit() {
      if (!(this.allFilled() && this.passwordsMatch())) {
        return false;
      }

      this.$validator.errors.clear();
      this.ApiService.updatePassword(this.newPassword, this.oldPassword)
        .then(() => {
          this.oldPassword = '';
          this.newPassword = '';
          this.confirmNewPassword = '';
          this.renderKey += 1;

          this.alertBox({ type: 'info', message: 'Password updated' })
            .then().catch();
        })
        .catch((errors) => {
          _.each(errors, (errs, key) => {
            this.$validator.errors.add(`form-field-${key}`, errs[0]);
          });
        });
      return null;
    },
  },
};
</script>
